import React from "react";
import MensHealthPage from "../Components/MensHealth/MensHealthPage";

const MensHealth = () => {
  return <MensHealthPage />;
};

export default MensHealth;